import { render } from "./HeroiconsOutlineMailOpen.vue?vue&type=template&id=1ca7b1a6"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMailOpen.vue"]])

export default __exports__